// extracted by mini-css-extract-plugin
export default {"wrapper":"carousel-tabs-module--wrapper--e063b"};